export default "/images/c0c551e6a22ee2e7c473aac5d3355176.png";